import React from "react";
import FooterInfoSection from "./FooterInfoSection";
import FooterPartnerSection from "./FooterLogoSection";
import FooterBrandImage from "./FooterBrandImage";
import FooterContactSection from "./FooterContactSection";
import FooterOtherPortalsSection from "./FooterOtherPortalsSection";
import { FooterProps } from "@/page-builder/global/mappers/footer.mapper";

const Footer = ({ help, floatingCard, main }: FooterProps) => {
  return (
    <footer id="skip-navigation-footer">
      <div className="">
      <div className="w-full">
        <div className="flex flex-col xl:flex-row">
            <FooterContactSection
              title={help?.title}
              description={help?.description}
              formLink={help?.links}
            />
            <FooterOtherPortalsSection
              title={floatingCard?.title}
              portals={floatingCard?.links}
            />
          </div>
        </div>

        <div
          aria-hidden="true"
          className="border-1 xs:border-white md:border-transparent xl:border-transparent opacity-5 w-full absolute left-0"
          role="separator"
        ></div>

        <div className="bg-primary-600">
          <FooterBrandImage
            leftLogo={main?.logo}
            leftLogoAlt={main?.logo.alt}
          />
          <FooterPartnerSection
            partnerTitle={main?.partners?.title}
            partnerLogos={main?.partners?.logos}
            fundingTitle={main?.sponsors?.title}
            fundingLogos={main?.sponsors?.logos}
          />

          <FooterInfoSection
            socialLinks={main?.socialMedias}
            footerLinks={main?.mainLinks}
            copyrightText={main?.copyright}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
